(function ($) {

  $.fn.addRequiredPackageProductToCart = function () {
    let btn = $(this);
    let cont = btn.closest('.required-packages-container');
    let productId = cont.attr('data-productid');
    let variantId = cont.attr('data-variantid');
    let lastItem = btn.attr('data-lastItem');
    let qty = parseInt(cont.attr('data-requiredQuantity'));
    let form = $('form.shopify-product-form');
    let qty_val = parseInt(form.find('input[name="quantity"]').val());

    let valid = form.find('input[name="quantity"]').validateProductForm();
    if (!valid) {
      return;
    }

    if (cont.hasClass('tpl-package')) {
      window.location.href = btn.attr('href');
      return;
    } else if (window.location.href.indexOf("cart") > -1) {
      $('.Cart__Checkout').trigger('click');
      return;
    }

    if (qty_val < qty) {
      form.find('input[name="quantity"]').val(qty);
    }


    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'jsonp',
      success: function (response) {

        let items = response.items;

        let currentKey = null;
        let inCart = false;
        items.forEach(function (item) {
          if (item.product_id == productId) {
            inCart = true;
            currentKey = item.key;
          }
        });

        let data = form.serialize();
        let url = '/cart/add.js';

        let unserialized = unserialize(data);
        unserialized['properties[_required_package_item]'] = true;

        if (inCart) {
          url = '/cart/change.js';

          if (currentKey) data.id = currentKey;
          unserialized.id = currentKey;
        }
        data = jQuery.param(unserialized);


        jQuery.ajax({
          type: 'POST',
          url: url,
          data: data,
          dataType: 'json',
          success: function () {
            window.location.href = btn.attr('href');
          }
        });

      }
    });

  };

  $.fn.validateProductForm = function() {
    let btn = $(this);
    let form = btn.closest('form');

    let valid = true;
    let personalized = false;

    if(form.find('.custom-field').length > 0) {
      form.find('.custom-field').each(function() {
        let field = $(this);

        if(field.val().length > 1) personalized = true;

        if(field.hasClass('required') && field.val().length < 1) {
          valid = false;
          field.closest('.field-container').addClass('error');
        }
        else if(field.hasClass('required') && field.hasClass('select') && field.val() == '0' ) {
          valid = false;
          field.closest('.field-container').addClass('error');
        }
        else {
          field.removeClass('error');
          field.closest('.field-container').removeClass('error');
        }
      });

      if (personalized) {
        if(form.find('input[name="properties[_personalized]"]').length < 1) {
          form.append('<input type="hidden" name="properties[_personalized]" value="true"/>');
        }
        else form.find('input[name="properties[_personalized]"]').val('true');
      }
    }

    return valid;
  };

  $(document).on('click', '.add-kit-to-cart', function (e) {
    setCookie('required_package_initialized', $(this).attr('data-kitid'), 1);
  });

  $(document).on('click', '.add-required-package-product-to-cart', function (e) {
    let valid = $(this).validateProductForm();
    e.preventDefault();
    if(!valid) {
      e.stopPropagation();
      return false;
    }
    else {
      $(this).addRequiredPackageProductToCart();
    }
  });

  $(document).on('click', '.CartItem.package-item .CartItem__Remove', function (e) {
    e.preventDefault();

    jQuery.ajax({
      type: 'GET',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function () {
        eraseCookie('required_package_initialized');
        eraseCookie('required_package_finished');
        window.location.href = '/cart';
      }
    });
  });

  $(function () {
    if (getCookie('required_package_initialized') == null) {
      document.querySelector('body').classList.remove('required-package-initialized');
    } else {
      initRequiredPackage();
    }
  });

  function initRequiredPackage(redirect = false) {
    let cont = document.querySelector('.required-packages-container');
    let kits = JSON.parse(cont.dataset.kits);
    let productId = parseInt(cont.dataset.productid);
    let packageId = parseInt(getCookie('required_package_initialized'));

    let kit = null;
    kits.forEach(function (_kit) {
      if (_kit.id == packageId) {
        kit = _kit;
      }
    });

    let products = kit.products;

    let currentIndex = null;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product.id == productId) {
        currentIndex = i;
      }
    }

    fetch("/cart.js")
      .then(response => response.json())
      .then(data => {
        parseRequiredPackage(data, products, currentIndex, redirect);
      }).catch(error => {
      console.log(error)
    });
  }

  function parseRequiredPackage(data, products, currentIndex, redirect) {
    let cont = document.querySelector('.required-packages-container');
    let productId = parseInt(cont.dataset.productid);
    let items = data.items;
    let prevItem = null;
    let nextItem = null;
    let currentItem = null;
    let currentCartItem = null;
    let total = products.length;

    let i = 0;
    let current = i;
    products.forEach(function (_product) {
      let inCart = false;
      items.forEach(function (item) {
        if (item.product_id == _product.product.id) {
          inCart = true;
          current++;
          if (item.product_id == productId) {
            currentCartItem = item;
          }
        }
      });
      if (!nextItem && !inCart && _product.product.id != productId) {
        nextItem = _product;
      } else if (_product.product.id == productId) {
        currentItem = _product;
      }
      i++;
    });

    if (currentIndex) {
      if (currentIndex > 0) prevItem = products[currentIndex - 1];
      currentItem = products[currentIndex];
      if ((currentIndex + 1) <= products.length) nextItem = products[currentIndex + 1];
    } else {
      prevItem = products[products.length - 1];
    }

    if (total == current) {
      setCookie('required_package_finished', true, 1);
    } else if (total > current) {
      eraseCookie('required_package_finished');
      if (window.location.href.indexOf("cart") > -1) {
        redirect = true
      }
    }

    let btn = cont.querySelector('.add-required-package-product-to-cart');

    if (nextItem) {
      btn.setAttribute('href', '/products/' + nextItem.product.handle);
      btn.dataset['lastItem'] = 'false';
    } else {
      btn.setAttribute('href', '/cart');
      btn.dataset['lastItem'] = 'true';
    }

    if (prevItem && currentIndex > 0) {
      cont.querySelector('.required-package-back').setAttribute('href', '/products/' + prevItem.product.handle);
      cont.querySelector('.required-package-back').classList.remove('hidden');
    }
    if (currentItem) {
      cont.dataset['requiredQuantity'] = currentItem.quantity;
    }

    document.querySelector('.quantity-selector__input').value = currentItem.quantity;
    document.querySelector('.quantity-selector__input').setAttribute('min', currentItem.quantity);
    if (currentCartItem) {
      for (var prop in currentCartItem.properties) {
        if (document.querySelector('input[name="properties[' + prop + ']"]').length > 0) {
          document.querySelector('input[name="properties[' + prop + ']"]').value = currentCartItem.properties[prop];
        }
      }
    }

    let progressContainer = cont.querySelector('.progress-container');
    progressContainer.querySelector('.current').innerHTML = current;
    progressContainer.querySelector('.total').innerHTML = total;
    progressContainer.querySelector('.percentage .bg').style.width = (parseInt(current) / parseInt(total)) * 100 + '%';

    console.log(cont)
    console.log(progressContainer)

    if (redirect) {
      if (nextItem) window.location.href = '/products/' + nextItem.product.handle
      else if (prevItem) window.location.href = '/products/' + prevItem.product.handle
    }
  }

  function unserialize(serializedData) {
    let urlParams = new URLSearchParams(serializedData); // get interface / iterator
    let unserializedData = {}; // prepare result object
    for (let [key, value] of urlParams) { // get pair > extract it to key/value
      unserializedData[key] = value;
    }

    return unserializedData;
  }
})
(jQuery);